import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReplyIcon from '@mui/icons-material/Reply';
import CancelIcon from '@mui/icons-material/Cancel';

import type { SvgIconComponent } from '@mui/icons-material';
import type { ButtonProps, Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

import { OrderActionEnum, OrderState } from 'desk-common';

export type OrderActionConfig = {
  label: string;
  action: OrderActionEnum;
  color: ButtonProps['color'];
  variant: ButtonProps['variant'];
  icon: SvgIconComponent;
  isAllowed?: boolean;
  sx?: SystemStyleObject<Theme>;
};

export const ACTION_BUTTON_BASE_SX: SystemStyleObject<Theme> = {
  borderRadius: 3,
  px: 3,
  textTransform: 'none',
};

export const ACTIONS_BY_STATE = (
  canApproveCostCenterOrders: boolean,
  canApprovePurchaserOrders: boolean,
  canEditAllOrders: boolean,
  canEditOwnOrders: boolean,
  isOwner: boolean
): Partial<Record<OrderState, OrderActionConfig[]>> => ({
  [OrderState.PENDIENTE_APROBACION_CENTRO_COSTO]: [
    {
      label: 'Anular pedido',
      action: OrderActionEnum.DENY,
      color: 'error',
      variant: 'outlined',
      icon: BlockIcon,
      isAllowed: canApproveCostCenterOrders,
    },
    {
      label: 'Devolver pedido',
      action: OrderActionEnum.RETURNED,
      color: 'warning',
      variant: 'outlined',
      icon: ReplyIcon,
      isAllowed: canApproveCostCenterOrders,
    },
    {
      label: 'Aprobar',
      action: OrderActionEnum.PREAPPROVE,
      color: 'success',
      variant: 'contained',
      icon: CheckCircleIcon,
      isAllowed: canApproveCostCenterOrders,
      sx: {
        fontWeight: 700,
      },
    },
  ],
  [OrderState.BORRADOR]: [
    {
      label: 'Cancelar',
      action: OrderActionEnum.CANCEL,
      color: 'error',
      variant: 'outlined',
      icon: CancelIcon,
      isAllowed: canEditAllOrders || (canEditOwnOrders && isOwner),
    },
  ],
  [OrderState.PENDIENTE_APROBACION_AREA_COMPRAS]: [
    {
      label: 'Aprobar',
      action: OrderActionEnum.APPROVE,
      color: 'success',
      variant: 'contained',
      icon: CheckCircleIcon,
      isAllowed: canApprovePurchaserOrders,
    },
    {
      label: 'Rechazar',
      action: OrderActionEnum.REJECT,
      color: 'error',
      variant: 'outlined',
      icon: BlockIcon,
      isAllowed: canApprovePurchaserOrders,
    },
  ],
});
